// ** Third Party Components
import { Icon } from "components/icons";

// #####################################################

const DynamicLockIcon = ({
	privateData = false,
	customHeight,
	customMargin,
	customFill,
}) => {
	return (
		<Icon
			name={privateData ? "lock" : "unlock"}
			color={customFill}
			height={customHeight}
			customMargin={customMargin}
			verticalAlign={"text-top"}
		/>
	);
};

// #####################################################

export default DynamicLockIcon;
